<template>
  <div class="toast" :class="{ error: error, success: success }">
    {{ text }} <span class="btn" @click="dismiss">Dismiss</span>
  </div>
</template>

<script>
export default {
  name: "Toast",
  data() {
    return {
      text: null,
      error: false,
      success: false
    };
  },
  methods: {
    errorMsg(text) {
      this.text = text;
      this.error = true;
    },
    successMsg(text) {
      this.text = text;
      this.success = true;
      setTimeout(() => this.dismiss(), 5000);
    },
    dismiss() {
      this.$el.remove();
      this.$destroy();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./hive";
</style>
